/* eslint-disable react/prop-types */
import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { ReactComponent as EnterIcon } from "resources/enter-icon.svg";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    fontSize: 22,
    color: "#999999",
  },
  icon: {
    width: "25px",
    height: "25px",
  },
  containerIcon: {
    paddingTop: "15px",
  },
}));

function InitialChartDailyPromotionsComponent() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography variant="h6" className={classes.text}>
        Select your days in the calendar & press
      </Typography>
      <div className={classes.containerIcon}>
        <EnterIcon className={classes.icon} />
      </div>

      <Typography variant="h6" className={classes.text}>
        button to apply custom daily promotions
      </Typography>
    </div>
  );
}

export default InitialChartDailyPromotionsComponent;
